/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import VueCollapse from 'vue2-collapse'
import store from './store'
import Vuex from 'vuex'
import axios from 'axios'
import Print from 'vue-print-nb'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import rate from 'vue-rate'
import 'vue-rate/dist/vue-rate.css'
import i18n from './i18n'

Vue.use(rate)
Vue.use(VueToast);

axios.defaults.baseURL = 'https://algedoc-backend.herokuapp.com/api'
Vue.use(Print);
Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(VueCollapse)

Vue.use(ArgonDashboard)
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
